export default __webpack_public_path__ + "static/media/section4_ex.da774576.png";